import { computed, onMounted } from 'vue';
import { useBrowserLocation, useStorage } from '@vueuse/core';

export const useDebug = () => {
    const debugModeEnabled = useStorage('frontend-debug-enabled', false, localStorage);

    onMounted(() => {
        if (debugModeEnabled.value !== false) {
            console.log('📣📣📣 Debug mode enabled.');
        }
    });

    const location = useBrowserLocation();
    const onDevEnvironment = computed(
        () =>
            location.value.hostname === 'localhost' ||
            location.value.hostname === 'dccs-website-dev.dccsintra.net' ||
            debugModeEnabled.value !== false
    );

    const log = !onDevEnvironment.value ? () => {} : console.log.bind(console);
    const error = !onDevEnvironment.value ? () => {} : console.error.bind(console);

    return {
        log,
        error,
    };
};
